import React from "react";
import Head from "next/head";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../config/next-seo.config.js";
import { withRouter } from "next/router";
import revampData from '../../data/revampData.json';
import { websiteColors } from "../../themes/Theme.js";

const RevampResposibleDisclosure = () => {
    const resposibleDisclosureContent = revampData.data.listResponsibleDisclosurePolicies.data[0].ResponsibleDisclosurePolicyBodyHtml;

    return (
        <div style={{
            "--primaryWebsiteTheme": websiteColors.light.primaryWebsiteTheme,
            "--headingColor": websiteColors.light.headingColor,
            "--staticPagesHeading": websiteColors.light.staticPagesHeading,
            "--staticPagesLink": websiteColors.light.staticPagesLink,
            "--staticPagesTableBorder": websiteColors.light.staticPagesTableBorder
        }}>
            <NextSeo {...seoFunct("revampResposibleDisclosureSeo")} />
            <div className="figtree-family" dangerouslySetInnerHTML={{ __html: resposibleDisclosureContent }}></div>
        </div>
    );
};

export default withRouter(RevampResposibleDisclosure);
